module.exports = __webpack_public_path__ + "static/img/partner.b135843.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/partner.png
// module id = zR8L
// module chunks = 23